import React from 'react';

interface TabProps {
  status: number;
  text: string;
  number: number;
  color: string;
  selected: string;
  onClick: (idOdabraniTab: number, textOdabraniTab: string) => void;
}
export const Tab: React.FC<TabProps> = ({ status, text, number, color, selected, onClick }) => {
  return (
    <div onClick={() => onClick(status, text)} className={`tab ${selected === text ? 'tab-active font-h5-medium' : 'font-h5-regular'}`}>
      {text}
      {text !== 'All' && text !== 'Archived' && <div className={`tab__number margin-left-1 font-light bg-${color}-100`}>{number}</div>}
    </div>
  );
};
